import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { withDefaultStyles } from '../../utils/material-ui/hoc';
import { getKey } from './actions/auth';
import { loadConfig } from './actions/config';
import RoostifyContent from './containers/content';

class RoostifyMain extends React.Component<any, any> {
  public async componentDidMount() {
    const accessToken = this.props.authentication.session.id
    const tenantId = this.props.tenant.id
    await this.props.dispatch(loadConfig(accessToken, tenantId))
    await this.props.dispatch(getKey(accessToken, tenantId))
  }
  public render() {
    const { authentication, tenant } = this.props
    return (
      <div style={this.props.style}>
        <RoostifyContent authentication={authentication} tenant={tenant} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {...state };
}

export default withDefaultStyles(withRouter(connect(
  mapStateToProps,
)(RoostifyMain)));



// WEBPACK FOOTER //
// ./src/sub-projects/roostify/main.tsx